export enum AddGroupSteps {
  ConfigureStep = 0,
  MembersStep = 1,
  OwnersStep = 2,
  LicensesStep = 3,
  ContentStep = 4,
  NotifyStep = 5,
}
